// @flow
import React from 'react'
import PopoverLib from 'reactstrap/lib/Popover'
import Button from 'reactstrap/lib/Button'
import PopoverHeader from 'reactstrap/lib/PopoverHeader'
import PopoverBody from 'reactstrap/lib/PopoverBody'
import mustache from 'mustache'
import ScrollLock from 'react-scrolllock'
import isMobile from 'is-mobile'

import LoadableHtmlRender from './LoadableHtmlRender'

type PopoverProps = {
  buttonText?: string,
  content: string,
  id: string,
  onClose?: () => void,
  pushOpen?: boolean,
  target?: string,
  templateVariables?: any,
  title?: string,
  popoverText?: string,
}

type PopoverState = {
  pushOpen: boolean,
  show: boolean,
}

export default class Popover extends React.Component<PopoverProps, PopoverState> {
  buttonRef = React.createRef<HTMLElement>()
  popoverRef = React.createRef<HTMLElement>()

  static defaultProps = {
    buttonText: '?',
    onClose: () => {
    },
    pushOpen: false,
    templateVariables: {},
    title: '',
  }

  state = {
    show: false,
    pushOpen: false,
  }

  static getDerivedStateFromProps(nextProps: PopoverProps, prevState: PopoverState) {
    if (nextProps.pushOpen !== prevState.pushOpen && !!nextProps.pushOpen) {
      return {
        pushOpen: nextProps.pushOpen,
        show: true,
      }
    } else if (nextProps.pushOpen !== prevState.pushOpen) {
      return {
        pushOpen: nextProps.pushOpen,
      }
    }
    return null
  }

  componentDidUpdate(prevProps: PopoverProps) {
    if (!prevProps.pushOpen && this.props.pushOpen) {
      document.addEventListener('click', this.handleOutsideClick, false)
    }
  }

  componentWillUnmount() {
    this.removeEventListener()
  }

  removeEventListener = () => {
    document.removeEventListener('click', this.handleOutsideClick)
  }

  handleOnClick = () => {
    if (typeof this.props.onClose === 'function' && this.state.show) {
      this.props.onClose()
    }
    this.setState({ show: !this.state.show })
    this.removeEventListener()
  }

  handleOnToggle = (event) => {
    if (event) {
      this.setState((state) => {
        if (state.show) {
          this.removeEventListener()
        } else {
          setTimeout(() => {
            document.addEventListener('click', this.handleOutsideClick, false)
          }, 100)
        }
        return { show: !state.show }
      })
    }
  }

  handleOutsideClick = (event: Event) => {
    if (this.popoverRef.current && this.popoverRef.current.contains(event.target)) {
      return null
    } else if (this.buttonRef.current && this.buttonRef.current.contains(event.target)) {
      return null
    }
    this.handleOnClick()
  }

  render = () => {
    const { target } = this.props
    return (
      <React.Fragment>
      <div
        className="cursor-pointer"
        id={`${this.props.id}-button`} innerRef={this.buttonRef}
        key={`${this.props.id}-button`}
        onBlur={this.handleOnBlur}
        onClick={this.handleOnToggle}
      >
        <Button
          className='btn btn-help'
          outline
          tabIndex='-1'
        >
          {this.props.buttonText}
        </Button>

        {this.props.popoverText && (
          <span className="pl-3">
          {this.props.popoverText}
        </span>
        )}
      </div>

      <PopoverLib
        boundariesElement='viewport'
        id={`${this.props.id}-popover`}
        innerRef={this.popoverRef}
        isOpen={this.state.show}
        key={`${this.props.id}-popover`}
        target={target ? target : `${this.props.id}-button`}
        trigger="click"
      >
        {this.props.title &&
        <PopoverHeader>
          {this.props.title}
          <div className='float-right'>
            <span className='pfp pfp-close p-1 h3 cursor-pointer' onClick={this.handleOnClick}/>
          </div>
        </PopoverHeader>
        }
        <PopoverBody>
          {!this.props.title &&
          <div className='text-right' style={{ height: 10 }}>
            <span className='pfp pfp-close p-1 h3 cursor-pointer' onClick={this.handleOnClick}/>
          </div>
          }
          <LoadableHtmlRender label={mustache.render(this.props.content, this.props.templateVariables)}/>
        </PopoverBody>
        {isMobile() && <ScrollLock/>}
      </PopoverLib>
      </React.Fragment>)
  }
}
